module.exports = __webpack_public_path__ + "hyperion-v2-static/img/circle.cc25be2d.png";